/*
* author: yangyulong
*/
import { ajax } from '@/utils/request';

const api = {
    // 自定义表单分类查询
    getClassify() {
        return ajax({
            method: 'get',
            url: `form-mgt/classify`,
        });
    },

    // 表单查询
    getFromLists(data: any) {
        return ajax({
            method: 'get',
            url: `form-mgt/form`,
            data
        });
    },

    // 新增表单分类
    addClassify(classifyName: string) {
        return ajax({
            method: 'post',
            url: `form-mgt/classify?classifyName=${classifyName}`,
        });
    },

    // 修改表单分类
    editClassify(data: any) {
        return ajax({
            method: 'put',
            url: `form-mgt/classify/${data.id}?classifyName=${data.classifyName}`,
        });
    },

    // 移除表单分类
    deleteClassify(id: number) {
        return ajax({
            method: 'delete',
            url: `form-mgt/classify/${id}`,
        });
    },

    // 表单启用
    enableFrom(id: number) {
        return ajax({
            method: 'put',
            url: `form-mgt/form/${id}/enable`,
        });
    },

    // 表单禁用
    disableFrom(id: number) {
        return ajax({
            method: 'put',
            url: `form-mgt/form/${id}/disable`,
        });
    },

    // 表单移除
    deleteFrom(id: number) {
        return ajax({
            method: 'delete',
            url: `form-mgt/form/${id}`,
        });
    },


    // ------------
    // 表单新增
    addForm(data: any) {
        return ajax({
            method: 'POST',
            url: `form-mgt/form`,
            data
        });
    },

    // 表单修改
    editForm(data: any) {
        return ajax({
            method: 'put',
            url: `form-mgt/form/${data.id}`,
            data
        });
    },

    //表单详情
    queryFormDetails(id: number) {
        return ajax({
            method: 'get',
            url: `form-mgt/form/${id}`,
        });
    },

};

export default api;